import { render, staticRenderFns } from "./ImageHotspots.vue?vue&type=template&id=8789f47c&v-if=inspiration&"
import script from "./ImageHotspots.vue?vue&type=script&lang=ts&"
export * from "./ImageHotspots.vue?vue&type=script&lang=ts&"
import style0 from "./ImageHotspots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports